import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { JSX } from 'react'
import { BlockerLayout } from './BlockerLayout'

interface GenericPendingBlockerProps {
  task: AutopilotTaskDto
}

export const GenericPendingBlocker = ({
  task,
}: GenericPendingBlockerProps): JSX.Element => {
  return (
    <BlockerLayout
      task={task}
      title="Task Pending"
      description="This task is waiting for a previous step to be completed."
    />
  )
}
